module.exports = __webpack_public_path__ + "media/assets/images/blog/tech_granpa-4b17d4b8d58a8ece5370a54f79fb7bc2.jpeg";